import styled from '../../../styles/theme';
import { AlertStyled } from '../AlertStyled';

export const AlertStyledOV = styled(AlertStyled)`
    .wrapper {
        background: ${p => p.theme.colors.primary};
    }
`;
